import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/mobile-home/5.jpg';
import _imports_1 from '@/assets/imgs/mobile-home/1.jpg';
import _imports_2 from '@/assets/imgs/mobile-home/2.jpg';
import _imports_3 from '@/assets/imgs/mobile-home/3.jpg';
import _imports_4 from '@/assets/imgs/mobile-home/4.jpg';

const _withScopeId = n => (_pushScopeId("data-v-32ef20d4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-container"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-img",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_3 = {
  class: "form-container"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode(" 留下您的信息"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 获取专属运动规划 ")], -1));

const _hoisted_5 = {
  class: "form"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-item__title pone-title"
}, "您的手机号", -1));

const _hoisted_7 = {
  class: "form-item__input"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-item__title requirement-title"
}, [/*#__PURE__*/_createTextVNode(" 您的运动需求是 "), /*#__PURE__*/_createElementVNode("div", {
  class: "data-tag tag-margin"
}, "可多选")], -1));

const _hoisted_9 = {
  class: "select-container"
};
const _hoisted_10 = ["onClick"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-img",
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-img",
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-img",
  src: _imports_3,
  alt: ""
}, null, -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-img",
  src: _imports_4,
  alt: ""
}, null, -1));

const _hoisted_15 = {
  class: "copyright"
};
const _hoisted_16 = {
  target: "_blank",
  href: "https://beian.miit.gov.cn/"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 蜀ICP备19019929号 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_field, {
    maxlength: "11",
    modelValue: _ctx.tel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.tel = $event),
    type: "tel",
    label: ""
  }, null, 8, ["modelValue"])]), _hoisted_8, _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => _ctx.handleActive(index),
      class: _normalizeClass(['select-item', item.active ? 'active' : ''])
    }, _toDisplayString(item.name), 11, _hoisted_10);
  }), 128))]), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.handleSubmit && _ctx.handleSubmit(...args)),
    class: _normalizeClass([_ctx.canSubmit ? 'active' : '', 'submit-btn'])
  }, " 立即提交 ", 2)])]), _hoisted_11, _hoisted_12, _hoisted_13, _hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("a", _hoisted_16, [_createTextVNode(" Copyright © 2021-" + _toDisplayString(new Date().getFullYear()) + " 成都沸彻科技有限公司 版权所有", 1), _hoisted_17, _hoisted_18])])]);
}